<dx-data-grid [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0"
  [showColumnLines]="true" [showRowLines]="true" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
  (onRowPrepared)="onRowPrepared($event)" (onRowUpdating)="onUpdating($event)" (onRowDblClick)="goToDetail($event.data)"
  [masterDetail]="{ enabled: true, template: 'detail' }" (onExporting)="onExporting($event)">

  <dxo-export [enabled]="true"></dxo-export>

  <dxo-editing mode="row" [allowAdding]="bEditable" [allowUpdating]="bEditable" [allowDeleting]="bEditable"
    [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
  <dxi-column dataField="id" [formItem]="{ visible: false }" [visible]="false" [allowEditing]="false">
  </dxi-column>

  <dxi-column name="addFile" [formItem]="{ visible: false }" [allowFiltering]="false" width="50" [visible]="bEditable"
    [allowSorting]="false" cellTemplate="linkCellTemplate" [allowEditing]="false" caption="">
  </dxi-column>
  @if (gestMatricole) {
    <dxi-column name="gestMatricola" [formItem]="{ visible: false }" [allowFiltering]="false"
      width="25" [allowSorting]="false" cellTemplate="gestMatricolaTemplate" [allowEditing]="false">
    </dxi-column>
  }
  <dxi-column dataField="attivo" caption="Attivo" dataType="boolean">
  </dxi-column>
  <dxi-column dataField="idTipo" caption="Tipologia" width="180">
    <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="tipo.immateriale" caption="Immateriale" [formItem]="{ visible: false }" [allowEditing]="false"
    dataType="boolean">
  </dxi-column>
  <dxi-column dataField='idCategoria' caption="Categoria" width="180" [allowEditing]="false">
    <dxo-lookup [dataSource]="listCatArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>
  <dxi-column dataField="codice" width="130" [sortIndex]="1" sortOrder="asc">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="descrizione">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="taglia">
  </dxi-column>

  <dxi-column dataField="identificativo" caption="Identificativo">
  </dxi-column>
  <dxi-column dataField="note" caption="Note">
  </dxi-column>


  <dxi-column dataField="scadenza" width="200" caption="GG Scadenza">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="scortaMinima" dataType="number">
  </dxi-column>
  <dxi-column dataField="scortaMassima" dataType="number">
  </dxi-column>
  <dxi-column dataField="giorniLeadTime" dataType="number">
  </dxi-column>
  <dxi-column dataField="qtaLottoRiordino" dataType="number">
  </dxi-column>
  <dxi-column dataField="giacenza" [visible]="!bEditable">
  </dxi-column>
  <dxi-column dataField="totCarichi" [visible]="!bEditable">
  </dxi-column>
  <dxi-column dataField="totScarichi" [visible]="!bEditable">
  </dxi-column>



  <div *dxTemplate="let d of 'linkCellTemplate'">
    <i (click)="goToAllega(d.data.id)" style="cursor: pointer;" class="dx-icon-upload" data-toggle="tooltip"
    data-placement="top" title="Allega documento"></i>
    @if (d.data.attivo) {
      <i (click)="onDisattivaArticoloClick(d)" style="cursor: pointer; margin-left: 4px;"
      class="fa fa-ban" data-toggle="tooltip" data-placement="top" title="Disattiva articolo"></i>
    }
  </div>

  <div *dxTemplate="let d of 'gestMatricolaTemplate'">
    @if (tipologiaHasMatricola(d.data.idTipo)) {
      <i (click)="onGestMatricolaTemplateClick(d)" style="cursor: pointer;" class="dx-icon-contentlayout"
      data-toggle="tooltip" data-placement="top" title="Visualizza matricole"></i>
    }
  </div>

  <div *dxTemplate="let articoli of 'detail'">
    <div class="master-detail-caption">{{"Allegati articolo " + articoli.data.codice}}</div>
    <dx-data-grid [dataSource]="getAllegati(articoli.data.id)" [showBorders]="true" [columnAutoWidth]="true">
      <dxi-column dataField="id" [visible]="false"></dxi-column>

      <dxi-column name="scaricaFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="scaricaFile"
        caption="" width="25">
      </dxi-column>
      <dxi-column name="vediFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="vediFile" caption=""
        width="25">
      </dxi-column>
      <dxi-column name="deleteFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="deleteFile" caption=""
        [visible]="bEditable" width="25">
      </dxi-column>
      <dxi-column dataField="nome"></dxi-column>
      <div *dxTemplate="let d of 'scaricaFile'">
        <i class="dx-icon-download" (click)="scaricaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
        data-placement="top" title="Scarica allegato"></i>
      </div>
      <div *dxTemplate="let d of 'vediFile'">
        @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
          <i class="dx-icon-image" (click)="visualizzaImmagine(d.data)" style="cursor: pointer;" data-toggle="tooltip"
          data-placement="top" title="Visualizza immagine"></i>
        }
        @if (endsWith(d.data.nomeFile, '.pdf')) {
          <i class="dx-icon-doc" (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
          data-placement="top" title="Visualizza allegato"></i>
        }
      </div>
      <div *dxTemplate="let d of 'deleteFile'">
        <i class="dx-icon-trash" (click)="eliminaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
        data-placement="top" title="Elimina allegato"></i>
      </div>
    </dx-data-grid>
  </div>

  <dxo-paging [pageSize]="20">
  </dxo-paging>
  <dxo-pager visible="true" allowedPageSizes="true" displayMode="full" showPageSizeSelector="true" showInfo="true"
    showNavigationButtons="true">
  </dxo-pager>

</dx-data-grid>

<dx-popup [width]="600" [height]="450" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Articolo">
</dx-popup>

@if (popupGestioneMatricoleVisible) {
  <app-popup-gestione-articoli-matricola
    (popupGestioneArticoliMatricolaEventEmitter)="onPopupGestioneMatricoleEvent()"
    [articolo]="selectedArticoloGestMatricola">
  </app-popup-gestione-articoli-matricola>
}
@if(popupDisattivaArticoloVisible){
  <app-popup-disattiva-articolo (popupDisattivaArticoloEventEmitter)="onPopupDisattivaArticoloEvent($event)"
    [articolo]="articoloDaDisattivare">
  </app-popup-disattiva-articolo>
}